/* eslint-disable array-callback-return */
import { Link } from "react-router-dom";
import { AddToCart, AddToWishList, BuyNow } from "../../../../Constant";
import { ProductDetailButtonProp } from "../../../../Type/EcommerceType";
import { useAppDispatch, useAppSelector } from "../../../../Redux-Toolkit/Hooks";
import { addToCartData } from "../../../../Redux-Toolkit/Reducers/CartSlice";

export const ProductDetailButton = ({ id }: ProductDetailButtonProp) => {
  const dispatch = useAppDispatch();
  const { productItem } = useAppSelector((state) => state.product);
  const singleItem = productItem;

  const AddProduct = (id: string | undefined | number) => {
    singleItem.map((item) => {
      if (item.id === id) {
        dispatch(addToCartData({ item: item, quantity: 1 }));
      }
    });
  };

  return (
    <div className="m-t-15 btn-showcase">
      <Link
        className="btn btn-primary"
        to={`${process.env.PUBLIC_URL}/ecommerce/cart`}
        onClick={() => {
          AddProduct(id);
        }}
        title="">
        <i className="fa fa-shopping-basket me-1"></i>
        {AddToCart}
      </Link>
      <Link className="btn btn-success" to={`${process.env.PUBLIC_URL}/ecommerce/checkout`} title="">
        <i className="fa fa-shopping-cart me-1"></i>
        {BuyNow}
      </Link>
      <Link className="btn btn-secondary" to={`${process.env.PUBLIC_URL}/ecommerce/wishlist`}>
        <i className="fa fa-heart me-1"></i>
        {AddToWishList}
      </Link>
    </div>
  );
};
